<template>
    <div class="position-relative">
        <DCard
            padding
        >
            <ContractsForm
                ref="createForm"
                :errors="errors"
                :contract="contract"
                :available-product-plans="availableProductPlans"
                :customer="customer"
                :options="options"
                :billing-cycles="billingCycles"
                :contract-term-units="contractTermUnits"
                :discount-types="discountTypes"
                :terms-and-conditions="termsAndConditions"
                :external-id-mapping="externalIdMapping"
                :existing-contract-groups="existingContractGroups"
                :fulfillment-module="fulfillmentModule"
                :payment-terms="paymentTerms"
                :has-sepa-mandate="hasSepaMandate"
                :payment-methods="paymentMethods"
                :fulfillment-strategies="fulfillmentStrategies"
                :is-invoice-before-renewal-enabled="isInvoiceBeforeRenewalEnabled"
                :orders="orders"
                :is-addon="isAddon"
                :previous-contract-options="previousContractOptions"
                :billing-types="billingTypes"
                :dns-providers="dnsProviders"
                @submit="storeContract"
            />
        </DCard>
    </div>

    <OptionChangeConfirmationModal
        :show-modal="showConfirmationModal"
        :changed-options="pendingChanges"
        :subject="customer.name"
        @update:showModal="showConfirmationModal = $event"
        @close-modal="showConfirmationModal = false"
        @confirm="confirmAndSubmit"
    />
</template>

<script>
import CustomerBase from '~@/Pages/Customers/Base'
import App from '~@/App.vue'

import ContractsForm from '~@/Components/Customers/Contracts/Form'
import OptionChangeConfirmationModal from '~@/Components/Customers/Contracts/Modals/OptionChangeConfirmationModal'

export default {
    name: 'CustomerContractEdit',
    components: {
        ContractsForm,
        OptionChangeConfirmationModal
    },
    layout: [App, CustomerBase],
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        customer: {
            type: Object,
            default: () => { return {} }
        },
        contract: {
            type: Object,
            default: () => { return {} }
        },
        availableProductPlans: {
            type: Array,
            default: () => { return [] }
        },
        options: {
            type: Object,
            default: () => { return {} }
        },
        billingCycles: {
            type: Array,
            default: () => { return [] }
        },
        contractTermUnits: {
            type: Array,
            default: () => { return [] }
        },
        discountTypes: {
            type: Array,
            default: () => { return [] }
        },
        termsAndConditions: {
            type: Array,
            default: () => { return [] }
        },
        externalIdMapping: {
            type: Object,
            default: () => { return {} }
        },
        existingContractGroups: {
            type: Array,
            default: () => { return [] }
        },
        fulfillmentModule: {
            type: String,
            default: null
        },
        paymentTerms: {
            type: Array,
            default: () => { return [] }
        },
        hasSepaMandate: {
            type: Boolean,
            default: () => false
        },
        paymentMethods: {
            type: Array,
            default: () => { return [] }
        },
        isInvoiceBeforeRenewalEnabled: {
            type: Boolean,
            default: () => false
        },
        activeBreadCrumb: {
            type: String,
            default: () => 'basic_information'
        },
        fulfillmentStrategies: {
            type: Array,
            default: () => { return [] }
        },
        orders: {
            type: Array,
            default: () => { return [] }
        },
        isAddon: {
            type: Boolean,
            default: () => false
        },
        previousContractOptions: {
            type: Array,
            default: () => { return [] }
        },
        billingTypes: {
            type: Array,
            default: () => { return [] }
        },
        dnsProviders: {
            type: Array,
            default: () => { return [] }
        }
    },
    data () {
        return {
            showConfirmationModal: false,
            pendingChanges: [],
            pendingForm: null,
        }
    },
    methods: {
        storeContract (form) {
            const changes = this.checkConfigurationChanges(form.config_values)

            if (changes.length > 0) {
                this.pendingChanges = changes
                this.pendingForm = form
                this.showConfirmationModal = true
                return
            }

            this.executePut(form)
        },

        checkConfigurationChanges (currentValues) {
            const originalValues = this.contract.options || {}
            const changes = []

            Object.keys(currentValues).forEach(key => {
                const original = originalValues[key]
                const currentVal = currentValues[key]

                if (
                    original &&
                    original.value !== currentVal.value &&
                    original.isConfirmationNeeded === true
                ) {
                    changes.push({
                        option: key,
                        texts: original.confirmationTexts || []
                    })
                }
            })

            return changes
        },

        executePut (form) {
            form.put(this.$route('customers.customers.contracts.update', {
                customer: this.customer.id,
                contract: this.contract.id
            }))
        },

        confirmAndSubmit () {
            this.showConfirmationModal = false
            if (this.pendingForm) {
                this.executePut(this.pendingForm)
            }
        }
    }
}
</script>
